import type { ReactNode } from "react";

export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="auth-shell">
      <div className="auth-card">
        <span className="tape" aria-hidden="true" />
        {children}
      </div>
    </div>
  );
}
